import type libBootstrap from 'bootstrap';

// ----------------------------------------------------------------------------

type TypeGlobalBootstrap = typeof globalThis & {
    bootstrap?: typeof libBootstrap;
};

// ----------------------------------------------------------------------------

let bootstrap: typeof libBootstrap | undefined;

// ----------------------------------------------------------------------------

function resolveGlobalBootstrap(): typeof libBootstrap | undefined {
    const globalObject = globalThis as TypeGlobalBootstrap;

    return globalObject.bootstrap;
}

function setBootstrap(ex: typeof libBootstrap): void {
    if (bootstrap && bootstrap !== ex) {
        console.warn('Bootstrap has already been initialized');
    }

    bootstrap = ex;
}

function getBootstrap(): typeof libBootstrap {
    bootstrap ??= resolveGlobalBootstrap();

    if (!bootstrap) {
        throw new Error('Operation requires bootstrap. Ensure it is loaded before use.');
    }

    return bootstrap;
}

function hasBootstrap(): boolean {
    return bootstrap != null || resolveGlobalBootstrap() != null;
}

// ----------------------------------------------------------------------------

export { getBootstrap, hasBootstrap, setBootstrap };
